import { render, staticRenderFns } from "./UserCreateDetailsTab.vue?vue&type=template&id=0f6a66cc"
import script from "./UserCreateDetailsTab.vue?vue&type=script&lang=ts"
export * from "./UserCreateDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports